import React from 'react';
import {Route, useRouteMatch} from "react-router-dom";
import CheckoutProvider from "../../Providers/CheckoutProvider";
import CheckoutSignupOrRegisterPage from "../CheckoutSignupOrRegisterPage";
import DeliveryOptions from "./DeliveryOptions";
import PaymentOptions from "./PaymentOptions";
import Receipt from "./Receipt";


const CheckoutDeliveryPage = () => {
    const route = useRouteMatch();
    console.log('Route ', route);
    return <CheckoutProvider>
        <Route exact path="/cart/checkout" component={CheckoutSignupOrRegisterPage}/>
        <Route exact path="/cart/checkout/delivery-options" component={DeliveryOptions}/>
        <Route exact path="/cart/checkout/payment-options" component={PaymentOptions}/>
        <Route path="/cart/checkout/receipt/:orderUuid" component={Receipt}/>
    </CheckoutProvider>
};

export default CheckoutDeliveryPage;